import {
  Avatar, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2)
  },
  authUser: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& $body': {
      backgroundColor: '#dfefe0',
    }
  },
  inner: {
    display: 'flex',
    maxWidth: 500
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  body: {
    backgroundColor: '#dceaff',
    minWidth: 200,
    color: theme.palette.text.primary,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2)
  },
  content: {
    marginTop: theme.spacing(1)
  },
  footer: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));


function ConversationMessage({ message, imageList, TechnicianId, className, ...rest }) {
  const classes = useStyles();
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: '0', ErrorDescription: 'İşleminiz başarı ile gerçekleştirildi.' });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const history = useHistory();

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const YorumSil = (event) => {
    confirmAlert({
      message: 'Yorumunuz silinecektir. Onaylıyor musunuz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => YorumSilEvet(event)
        },
        {
          label: 'Hayır',
          onClick: () => { }
        }
      ]
    });
  };
  const YorumSilEvet = (event) => {
    const dataMessage = [{
      AppNr: message.BASVURU_NO,
      ServiceShopId: message.BIRIM_KODU,
      CommentRequested: 0,
      UserId: message.TEKNISYEN_KODU,
      Comment: '',
      Operation: 0,
      CommentId: message.SIRA_NO_PARAM,
      Decision: 0,
    }];
    const configMessage = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisComment', dataMessage, configMessage).then((response) => {
      const ResponseDataMessage = response.data;
      setresponseMessage(ResponseDataMessage);
      if (ResponseDataMessage.ErrorCode === '0') {
        history.push('/chat');
      } else {
        setUyariTip('error');
        setUyari(true);
      }
    }).catch((error) => {
      setresponseMessage({ ErrorCode: 10, ErrorDescription: 'Bir hata oluştu!..' });
      setUyariTip('error');
      setUyari(true);
    });
  };

  return (
    <div className={clsx(classes.root, { [classes.authUser]: message.Sender === TechnicianId }, className)}>
      {
        uyari && <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
      }
      <div className={classes.inner}>
        <Avatar
          className={classes.avatar}
          src={imageList}
        />
        <div>
          <div className={classes.body}>
            <div>
              <Typography variant="h6">
                {message.SenderName}
              </Typography>
            </div>
            <div className={classes.content}>
              <Typography
                color="inherit"
                variant="body1"
              >
                {message.MessageContent}
              </Typography>
            </div>
          </div>
          <div className={classes.footer}>
            <Typography
              className={classes.time}
              variant="body2"
            >
              {message.Date}
            </Typography>
            {/* {
              (parseInt(message.sender.authUser) === 1) &&
              <IconButton size="small" onClick={() => YorumSil()}>
                <HighlightOffIcon color="error" />
              </IconButton>
            } */}
          </div>
        </div>
      </div>
    </div>
  );
}

ConversationMessage.propTypes = {
  className: PropTypes.string,
  message: PropTypes.object.isRequired
};

export default ConversationMessage;
